import type { AboutCopy } from '../types/about';

export const aboutEs: AboutCopy = {
  seo: {
    title: 'Sobre nosotros',
    description:
      'SafestMenu está creado y operado por transfactor.dev, un equipo de desarrollo de software senior en Bucarest, Rumanía - certificado ISO 9001 e ISO/IEC 27001.',
  },
  hero: {
    eyebrow: 'Sobre nosotros',
    heading: 'Hecho por personas que se dedican a crear software - y que comen fuera muy a menudo.',
  },
  story: {
    intro:
      'SafestMenu nació de una observación sencilla: los menús de papel son caros de reimprimir, imposibles de mantener actualizados, pasan por las manos de cientos de clientes y acaban tirados a pilas. Todos los restaurantes con los que hablamos tenían el mismo problema - y ningún tiempo para una solución complicada.',
    easyIntro:
      'Así que construimos el menú que nosotros mismos querríamos en nuestro restaurante: uno que configuras en minutos, actualizas desde el móvil y nunca vuelves a imprimir. ',
    easyHighlight: 'Fácil de usar',
    easyOutro: ' no era una función más en una lista - era el objetivo de todo.',
    imageAlt: 'Una tarjeta de mesa con código QR de SafestMenu en la mesa de una cafetería junto a un café exprés',
  },
  team: {
    heading: 'El equipo detrás',
    linkIntro: 'SafestMenu está creado y operado por ',
    linkText: 'transfactor.dev',
    linkOutro:
      ', un equipo de desarrollo de software senior con sede en Bucarest, Rumanía. transfactor.dev diseña, construye y lanza productos web, sistemas de IA y herramientas internas - más de veinte productos lanzados y dieciocho años de experiencia combinada, trabajando con certificación ISO 9001 e ISO/IEC 27001.',
    reliability:
      'Esto importa para ti de una forma muy concreta: SafestMenu no es un proyecto paralelo que desaparecerá el año que viene. Lo mantiene, protege y mejora el mismo equipo, cada semana.',
  },
  beliefs: {
    heading: 'En qué creemos',
    items: [
      'El software para restaurantes debería ser más sencillo que llevar un restaurante.',
      'Los clientes merecen menús honestos: precios claros, fotos reales, alérgenos marcados.',
      'Menos papel en la basura es bueno para todos - incluido tu bolsillo.',
    ],
  },
  cta: {
    label: 'Prueba SafestMenu gratis',
  },
};
